export default __webpack_public_path__ + "static/media/3d.ddce6839.png";